var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project-information" },
    [
      _vm.isEngineer || _vm.canTenantRead
        ? [
            _vm.isTenant && !_vm.isWithdrawn
              ? _c("div", { staticClass: "btn-group-for-tenant text-right" }, [
                  !_vm.isEditing
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn--darkblue",
                          on: { click: _vm.edit },
                        },
                        [_vm._v(_vm._s(_vm.$t("action.edit")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isEditing
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn--darkblue",
                          on: { click: _vm.cancel },
                        },
                        [_vm._v(_vm._s(_vm.$t("action.cancel")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isEditing && _vm.status === _vm.draft
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn--orange",
                          on: { click: _vm.save },
                        },
                        [_vm._v(_vm._s(_vm.$t("action.save")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isEditing
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn--orange",
                          on: { click: _vm.openSubmitConfirm },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.status === _vm.draft
                                ? _vm.$t("action.submit")
                                : _vm.$t("action.save")
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "project-overview" },
              [
                _c("ProjectBasicInformation", {
                  ref: "proj-basic-infor",
                  staticClass: "project-overview__info",
                  class: _vm.baseInfoClass,
                  attrs: { editable: _vm.isEditing && _vm.canEdit },
                }),
                _vm._v(" "),
                !_vm.isEditing
                  ? _c("ProjectQuickLinks", {
                      staticClass: "project-overview__link",
                      attrs: { openTnc: _vm.openTnc },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tenant-users" },
              [
                _c("TenantRepresentative", {
                  ref: "tenant-representative",
                  attrs: { editable: _vm.isEditing && _vm.canEdit },
                }),
              ],
              1
            ),
          ]
        : _c("p", [
            _vm._v("\n    " + _vm._s(_vm.$t("noTabPermission")) + "\n  "),
          ]),
      _vm._v(" "),
      _c("TermsAndConditions", {
        ref: "tncProjectInfoViewPage",
        attrs: {
          modalId: "tncProjectInfoViewPage",
          acceptCallback: _vm.isloadPageTncPopup
            ? _vm.loadPageTncCallback
            : _vm.termsConditionsCallback,
        },
      }),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "submitConfirmModal",
        attrs: {
          modalId: _vm.submitModalId,
          confirmTitle: _vm.$t("confirmSubmit"),
        },
      }),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "diffTenancyInfo",
          attrs: { showCloseBtn: false, modalId: "diffTenancyInfo" },
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("p", { staticClass: "font-bold" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("tenantProjects.diffTenancyInfoHint")) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.closeDiffTenancyInfoModal()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.ok")))]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("InviteModal", {
        ref: "inviteModal",
        attrs: {
          accountsList: _vm.toInviteAccountsList,
          onInviteClick: _vm.inviteAccountsList,
          listTitle: _vm.$t("tenancy.tenantRepresentative"),
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }